import { render, staticRenderFns } from "./AppGameWorkIcon.vue?vue&type=template&id=9ac21250"
import script from "./AppGameWorkIcon.vue?vue&type=script&lang=js"
export * from "./AppGameWorkIcon.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports